import ExternalLogger from "core-ui/client/src/app/ExternalLogger";

import idProofEvents from "./events/IDProofEvents";

var otpVerificationCodeEntryController = function (
    $scope,
    $injector,
    eventBus,
    $stateParams,
    redirectService,
    otsAccountOpenFactory,
    otsRegistrationService
) {
    var vm = this;
    var $state = $injector.get("$state");
    var logger = ExternalLogger.getInstance("otpVerificationCodeEntryController");

    $scope.isOtsUser = $stateParams.flowName === "OTS";
    vm.options = {
        onConfirm: function (phoneNumber, data) {
            logger.debug("otpVerificationCodeEntryController - onConfirmClick - [{0}]", [
                phoneNumber ? phoneNumber : null
            ]);
            eventBus.dispatch(idProofEvents.OTP_AGREE_ENTER_CODE, this);
            var params = {
                phoneNumber: phoneNumber ? phoneNumber : null
            };
            if (data.flowName === "otsAccountSetup") {
                //Get session data
                let formData = otsRegistrationService.getFormData();

                // IF OTS Call Shadowaccount if successfull redirect otherwise throw error
                otsAccountOpenFactory
                    .createShadowAccountOTS(phoneNumber)
                    .then(
                        //Get data and redirect
                        function () {
                            redirectService.redirect(data, "ALL", formData.context);
                        }
                    )
                    .catch(function () {
                        $state.go("idProofError", { errorCode: "idProofOTS" });
                    });
            } else {
                $state.go("accountSetup", params);
            }
        },

        onOtpError: function (state) {
            logger.debug("state - [{0}]", [state ? state : null]);
            var params = {
                optOut: "optOut-Modal"
            };
            if ($scope.isOtsUser) {
                $state.go("idProofError", { errorCode: "idProofOTS" });
            } else {
                $state.go("mailPin", params);
            }
        },
        phoneNumber: null
    };

    vm.phoneNumber = null;
    vm.getPhoneNumber = function () {
        if ($state.params && $state.params.phoneNumber) {
            var phoneNumberParam = $state.params.phoneNumber;
            vm.phoneNumber = phoneNumberParam.replace(/\D+/g, "");
        }

        return vm.phoneNumber;
    };

    var otpService = $injector.get("otpService");
    vm.openOTPNoCodeModal = otpService.openOTPNoCodeModalModal;

    vm.init = function () {
        var method = "init()";
        var phoneNumber = vm.getPhoneNumber();
        if (phoneNumber) {
            vm.options.phoneNumber = phoneNumber;
            logger.debug("otpVerificationCodeEntryController - {0} - phoneNumber provided: [{1}]", [
                method,
                phoneNumber
            ]);
        } else {
            logger.debug("otpVerificationCodeEntryController - {0} - phoneNumber NOT provided.", [
                method
            ]);
        }
    };

    vm.init();
};

otpVerificationCodeEntryController.$inject = [
    "$scope",
    "$injector",
    "eventBus",
    "$stateParams",
    "redirectService",
    "otsAccountOpenFactory",
    "otsRegistrationService"
];
export default otpVerificationCodeEntryController;
